import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-no-auth',
  templateUrl: './layout-no-auth.component.html',
})
export class LayoutNoAuthComponent {

}
